/**
 * For all below collections we need to make sure that the usage of collection is not modifying the original one, so we are applying slice(0) on collection, and that clones it, removing reference to original collection
 */

export const statisticsScales = () => {
  const collection = [
    {
      handle: 'day',
      name: 'Dag'
    },
    {
      handle: 'week',
      name: 'Vecka'
    },
    {
      handle: 'month',
      name: 'Månad'
    },
  ]

  return collection.slice(0)
}

export const areaCategories = () => {
  const collection = [
    {
      id: 1,
      name: 'Luleå'
    },
    {
      id: 2,
      name: 'Sundsvall'
    },
    {
      id: 3,
      name: 'Stockholm'
    },
    {
      id: 4,
      name: 'Malmö'
    },
  ]

  return collection.slice(0)
}

export let contractTypes = () => {
  const collection = [
    {
      handle: 1,
      name: 'Fast pris 6 månader'
    },
    {
      handle: 2,
      name: 'Fast pris 1 år'
    },
    {
      handle: 4,
      name: 'Fast pris 2 år'
    },
    {
      handle: 5,
      name: 'Fast pris 3 år'
    },
    {
      handle: 6,
      name: 'Fast pris 4 år'
    },
    {
      handle: 7,
      name: 'Fast pris 5 år'
    },
    {
      handle: 9,
      name: 'Rörligt pris 1 år'
    },
    {
      handle: 10,
      name: 'Rörligt pris löpande'
    },
    {
      handle: 13,
      name: 'Mixavtal 1 år'
    }
  ]

  return collection.slice(0)
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/services/Data/GeneralData.js